import { LOCAL_TRANSLATION_LANGUAGE } from '../constants/app.constant';

export interface MultilingualDropdownInterface {
    id: string;
    languageName: string;
    local: string;
    isDefault: boolean;
}

export class MultilingualDropdownModel {
    id: string;
    languageName: string;
    local: string;
    isDefault: boolean;
    formattedLocal: string;

    constructor(private model: MultilingualDropdownInterface) {
        this.id = model.id;
        this.languageName = model.languageName;
        this.local = model.local;
        this.isDefault = model.isDefault;
        this.formattedLocal = LOCAL_TRANSLATION_LANGUAGE[model.local as keyof typeof LOCAL_TRANSLATION_LANGUAGE];
    }
}
